(function (app) {
    app.provider("externalAccountApi", [function () {
        this.$get = ["externalsApiGateway", function (externalsApiGateway) {
            var service = {};

            service.getFigAccounts = function () {
                return externalsApiGateway.getArray("/Accounts/External/Fig");
            };

            service.getFigAccount = function(guid) {
                return externalsApiGateway.get("/Accounts/External/Fig/" + guid);
            };

            service.getAcmAccount = function (guid) {
                return externalsApiGateway.get("/Accounts/External/Investment/" + guid);
            };

            service.getAcmAccounts = function () {
                return externalsApiGateway.getArray("/Accounts/External/Alphastar");
            };

            service.getArcPolicyRequirements = function (policyGuid) {
                return externalsApiGateway.getArray("/Accounts/External/Fig/" + policyGuid + "/Requirements");
            };

            service.getAcmAccountRequests = function (accountGuid) {
                return externalsApiGateway.getArray("/Accounts/External/Alphastar/" + accountGuid + "/Requests");
            };

            return service;
        }];
    }]);
})(window.app);